import { templateApi } from '@/api/templateApi'

const types = {
    SET_ALL_TEMPLATES_CATEGORY: 'SET_ALL_TEMPLATES_CATEGORY',
    SET_ALL_TEMPLATES: 'SET_ALL_TEMPLATES',
    SET_ALL_TEMPLATES_DICTIONARIES: 'SET_ALL_TEMPLATES_DICTIONARIES',
};
const state = {
    all: [],
    templates: [],
    dictionaries: [],
};

const mutations = {
    [types.SET_ALL_TEMPLATES_CATEGORY]: (state, value) => {
        state.all = value
    },
    [types.SET_ALL_TEMPLATES]: (state, value) => {
        state.templates = value
    },
    [types.SET_ALL_TEMPLATES_DICTIONARIES]: (state, value) => {
        state.dictionaries = value
    },
}

const actions = {
    async getAllTemplatesCategory({ commit, state }, loadCached) {
        const load = async () => {
            const {CategoryList, TemplateList} = await templateApi.getTemplatesAndCategories()
            commit(types.SET_ALL_TEMPLATES_CATEGORY, CategoryList)
            commit(types.SET_ALL_TEMPLATES, TemplateList)
        }

        if (loadCached && (state.all && state.all.length !== 0 && state.templates && state.templates.length !== 0)) {
            load()
        } else {
            await load()
        }
    },
    async getAllTemplateDictionaries({ commit, state }, loadCached) {
        const load = async () => {
            const templateDictionaries = await templateApi.getWidgetsTemplateHelps()
            commit(types.SET_ALL_TEMPLATES_DICTIONARIES, templateDictionaries)
        }

        if (loadCached) {
            load()
        } else {
            await load()
        }
    },
}

const getters = {
    getHelpByWidgetsTemplateID: state => TemplateID => {
        return state.dictionaries.find(t => t.TemplateID.toString() === TemplateID.toString())
    },
    getDictionariesList: state => state.dictionaries,
    getCategories: state => state.all,
    getNotEmptyCategories: state => {
        return state.all.filter(category => {
            return !!(state.templates
                .filter(template => template.CategoryList && template.CategoryList.includes(category.CategoryID))
            ).length
        })
    },
    getTemplates: state => state.templates,
    getWidgetTemplate: state => templateId => {
        if (!templateId) {
            return
        }
        return state.templates.find(t => t.TemplateID.toString() === templateId.toString())
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
